<template>
  <el-dialog title="实名认证" :visible.sync="visible" width="680px" custom-class="front-realname-dialog" append-to-body :close-on-click-modal="false" @closed="profile = {}">
    <RealnameForm v-if="visible" :profile="profile" allow-later @later="visible = false" @submitted="visible = false" />
  </el-dialog>
</template>

<script>
import RealnameForm from './RealnameForm.vue'
import { createRealnameLoginCheck } from '@/utils/realname'

export default {
  components: { RealnameForm },
  data() { return { visible: false, profile: {} } },
  created() {
    this.loginCheck = createRealnameLoginCheck({
      getToken: () => localStorage.getItem('front_token'),
      getAccount: async () => (await this.$api('/api/website/auth/me', 'get')).data || {},
      getProfile: async () => (await this.$api('/api/website/student/realname', 'get')).data || {},
      onOpen: profile => { this.profile = profile; this.visible = true },
    })
  },
  mounted() {
    window.addEventListener('front-login-success', this.checkAfterLogin)
    window.addEventListener('auth-changed', this.checkLogout)
    window.addEventListener('storage', this.checkLogout)
  },
  beforeDestroy() {
    this.loginCheck.reset()
    window.removeEventListener('front-login-success', this.checkAfterLogin)
    window.removeEventListener('auth-changed', this.checkLogout)
    window.removeEventListener('storage', this.checkLogout)
  },
  methods: {
    checkAfterLogin() { this.loginCheck.check() },
    checkLogout() { this.loginCheck.reset(); this.visible = false; this.profile = {} },
  },
}
</script>

<style lang="less">
.front-realname-dialog{max-width:calc(100vw - 28px);border-radius:12px;margin-top:6vh!important;margin-bottom:6vh}.front-realname-dialog .el-dialog__header{padding:24px 28px 10px}.front-realname-dialog .el-dialog__title{font-size:21px;font-weight:600;color:#28364d}.front-realname-dialog .el-dialog__body{padding:18px 28px 26px;max-height:calc(88vh - 70px);overflow-y:auto}.front-realname-dialog .el-dialog__headerbtn{top:25px;right:24px}
@media(max-width:600px){.front-realname-dialog .el-dialog__header{padding-left:20px;padding-right:20px}.front-realname-dialog .el-dialog__body{padding-left:20px;padding-right:20px}}
</style>
